import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { LocationType } from "../../domain/models";

@Injectable({providedIn: 'root'})
export class GetLocationTypeUsecase implements UseCase<undefined, LocationType[]> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(): Observable<LocationType[]> {
    return this.locationRepository.getLocationType();
  }
}
